/**
 * CreateGem use case: spend mana to create a level-1 gem in inventory.
 */

import { createGem } from "../../domain/session.js";
import type { GemType, NotEnoughMana } from "../../domain/types.js";
import type { RenderPort, AudioPort } from "../ports.js";
import { sessionToView } from "../state-view.js";

export interface CreateGemDeps {
  render: RenderPort;
  audio: AudioPort;
  getSession(): import("../../domain/session.js").GameSession | null;
}

export function createCreateGem(deps: CreateGemDeps) {
  return function createGemUC(
    gemType: GemType
  ): { ok: true } | NotEnoughMana {
    const session = deps.getSession();
    if (!session) return { code: "NotEnoughMana" };
    const gem = createGem(session, gemType);
    if (!gem) return { code: "NotEnoughMana" };
    deps.render.update(sessionToView(session, "game"));
    deps.audio.play("click");
    return { ok: true };
  };
}
